<template>
  <div class="age-verify-overlay">
    <div class="age-verify-modal">
      <img src="@/assets/images/jamrock-logo.webp" fetchpriority=high alt="Logo" class="logo mb-4" width="120" height="120" />
      <h2>Verificación de Edad</h2>
      <p class="mb-4">Debes ser mayor de 18 años para acceder a este sitio.</p>
      <div class="d-flex gap-2">
        <button @click="verify(true)" class="btn btn-primary px-4 py-2">
          <FaIcon name="check" class="me-2" />
          Soy mayor de 18
        </button>
        <button @click="verify(false)" class="btn btn-outline-light px-4 py-2">
          <FaIcon name="times" class="me-2" />
          Soy menor
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineEmits } from 'vue'
const emit = defineEmits(['verified'])

const verify = (isAdult) => {
  if (isAdult) {
    localStorage.setItem('ageVerified', 'true');
    emit('verified');
  } else {
    // Redirigir a Google si es menor de edad
    window.location.href = 'https://www.google.com';
  }
};
</script>

<style scoped>
.age-verify-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10002;
}

.age-verify-modal {
  background: var(--black-color-3);
  padding: 2rem;
  border-radius: 1rem;
  text-align: center;
  max-width: 90%;
  width: 400px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.logo {
  width: 120px;
  height: auto;
  margin: 0 auto;
}

h2 {
  color: var(--white-color);
  margin-bottom: 1rem;
  font-size: 1.5rem;
}

p {
  color: var(--white-color-2);
  opacity: 0.8;
}

.btn {
  flex: 1;
  transition: all 0.3s ease;
}

.btn:hover {
  transform: translateY(-2px);
}

@media (max-width: 576px) {
  .age-verify-modal {
    padding: 1.5rem;
  }
  
  .btn {
    padding: 0.5rem !important;
    font-size: 0.9rem;
  }
}
</style>
